import { render, staticRenderFns } from "./Drawer.vue?vue&type=template&id=528d5586&"
import script from "./Drawer.js?vue&type=script&lang=js&"
export * from "./Drawer.js?vue&type=script&lang=js&"
import style0 from "./Drawer.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports